'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const API = require('common/infra/api/user');
const BlobAPIFactory = require('common/infra/api/blob-factory');
const User = require('common/domain/entity/user');

class Repository {
    constructor() {
        this._loginUserPromise = null;
        this._users = new Backbone.Collection();
    }

    get(id) {
        return new Promise((resolve, reject) => {
            const user = this._users.get(id);
            if(user) {
                resolve(user);
            } else {
                API.getUser(id)
                    .then(user => {
                        const u = this.buildUser(user);
                        this._users.add(u);
                        resolve(this._users.get(id));
                    }, reject);
            }
        });
    }

    getLoginUser() {
        if(this._loginUserPromise) {
            return this._loginUserPromise;
        }
        this._loginUserPromise = new Promise((resolve, reject) => {
            API.getLoginUser()
                .then(user => {
                    this._loginUser = this.buildUser(user);
                    this._users.add(this._loginUser);
                    resolve(this._loginUser);
                }, (reason) => {
                    const status = reason.status;
                    const type = reason.type;
                    if(status === 401) {
                        if (type == 'NotLoginError') {
                            resolve(null);
                        }
                        else if (type == 'NotSignupError') {
                            resolve(new User());
                        }
                    }
                    else {
                        reject(status, type);
                    }
                });
        });
        return this._loginUserPromise;
    }

    getJijiUser() {
        return API.getJijiUser()
                .then(jijiUser => {
                    return new User({
                        name: jijiUser.name,
                        mail_address_list: _.map(jijiUser.addresses, (a, index) => {
                            return {
                                mail_address: a,
                                primary: index == 0,
                                protected: true
                            }
                        })
                    });
                });
    }

    create(userJson) {
        const u = this.buildUser(userJson);
        return this._users.add(u, {merge: true});
    }

    buildUser(userJson) {
        let u = new User(userJson);
        //TODO: 以下の行は修正
        u.blobApi = BlobAPIFactory.buildUser();
        return u;
    }
}

module.exports = new Repository();



// WEBPACK FOOTER //
// ./common/domain/repository/user.js